<p-dialog
    visible="true"
    [maximizable]="false"
    [modal]="true"
    appendTo="body"
    [closable]="false"
    [style]="{ 'min-width': '275px' }"
>
    <p-header> {{ config.header }} </p-header>
    <form [formGroup]="pinFormGroup">
        <fieldset>
            <input pInputText autofocus type="text" formControlName="pin" />
        </fieldset>
    </form>
    <ng-template #footer >
        <button
            pButton
            label="Cancel"
            icon="pi pi-times"
            (click)="onCancel()"
            class="p-button-text p-button-danger"
        ></button>
        <button
            pButton
            label="Save"
            icon="pi pi-check"
            (click)="onSave(this.pinFormGroup.value)"
            class="p-button-text p-button-success"
            [disabled]="this.pinFormGroup.invalid"
        ></button>
    </ng-template>
</p-dialog>
